import request from '@/api/base'

// 获取楼层设备(不分页)
const getDeviceListbyLocation = (params) => {
  // params.mockApi = true
  return request.get('/portal/device/getDeviceListbyLocation', {params})
}
// 获取企业仪表列表
const getCompanyMeter = (params) => {
  return request.post('/portal/device/bill/getCompanyMeter', params)
}
// 保存企业仪表
const saveMeterNew = (params) => {
  return request.post('/portal/device/bill/saveMeterNew', params)
}
// 抄表记录导出
const exportMeterRecord = (params) => {
  return request.post('/portal/device/exportMeterRecord', params, {responseType: 'blob'})
}
// 开放接口
const getTaskCount = (params) => {
  return request.get('/admin/sys/sysParam/systemParameter', {params})
}
// 设备巡检计划板块
// 设备巡检计划列表接口
const getTaskCountList = (params) => {
  return request.post('/asset/equip/project/v1/list', params)
}
// 设备巡检计划删除接口
const deleteList = (params) => {
  return request.post('/asset/equip/project/v1/delete', params)
}
// 获取编号
const getOutCode = (params) => {
  return request.get('/asset/equip/project/v1/getCode', {params})
}
// 设备巡检计划启用设备接口
const enable = (params) => {
  return request.post('/asset/equip/project/v1/star', params)
}
// 设备巡检计划停用用设备接口
const disable = (params) => {
  return request.post('/asset/equip/project/v1/stop', params)
}
// 设备巡检计划下载模版接口
// const exportTem = (params) => {
//   return request.get('/equip/project/v1/templateDownLoad', {params}, 'blob')
// }
// 设备巡检计划下载模版接口
const exportTem = (params) => {
  return request({
    url: '/asset/equip/project/v1/templateDownLoad',
    responseType: 'blob',
    method: 'get',
    params: params
  })
}
// ipark
const getToken = (params) => {
  // auth/jwt/token
  // /portal/auth/getToken
  return request.post('/auth/jwt/token', params)
}
const getPingAnCookie = (params) => {
  // auth/jwt/token
  // /portal/auth/getToken
  return request.get('/portal/auth/getToken', {params})
}
// api
const getclientToken = (params) => {
  return request.get('/auth/client/token', {params})
}

// 设备维保计划修改保存接口
const updateProtect = (params) => {
  return request.post('/asset/v1/gfmassmaintenanceProject/v1/update', params)
}
// 保存维保计划信息
const saveProtect = (params) => {
  return request.post('/asset/v1/gfmassmaintenanceProject/saveMaiInfo', params)
}
// 设备维保计划板块
// 设备维保计划列表接口
const getProtectTaskCountList = (params) => {
  return request.post('/asset/v1/gfmassmaintenanceProject/selectMaiData', params)
}
// 设备维保计划删除接口
const deleteProtectList = (params) => {
  return request.post('/asset/v1/gfmassmaintenanceProject/v1/deleteMaiInfo', params)
}
// 设备巡检维保启用设备接口
const enableProtect = (params) => {
  return request.post('/asset/v1/gfmassmaintenanceProject/isStopUsing', params)
}
// 设备巡检维保停用用设备接口
const disableProtect = (params) => {
  return request.post('/asset/v1/gfmassmaintenanceProject/isStopUsing', params)
}

// 设备巡检维保下载模版接口
const exportTemProtect = (params) => {
  return request({
    url: '/asset/v1/gfmassmaintenanceProject/v1/templateDownLoad',
    responseType: 'blob',
    method: 'get',
    params: params
  })
}
// 设备巡检维保反查询
const getitemDetail = (params) => {
  return request.get(`/asset/v1/gfmassmaintenanceProject/v1/info/${params.bizid}`, {params})
}
// 设备巡检反查询附件
const getitemDetaillist = (params) => {
  return request.get('/asset/sys/gfmasscardattachment/v1/selectByRelateBizid', {params})
}

// 设备巡检计划反查询
const getxproDetail = (params) => {
  return request.get(`/asset/equip/project/v1/info/${params.bizid}`, {params})
}
// 设备巡检反查询附件
// const getitemDetaillist = (params) => {
//   return request.get('/asset/sys/gfmasscardattachment/v1/selectByRelateBizid', {params})
// }

// 设备巡检计划保存接口
const saveXProtect = (params) => {
  return request.post('/asset/equip/project/v1/save', params)
}
const updateXProtect = (params) => {
  return request.post('/asset/equip/project/v1/update', params)
}
// 获取维保巡检单位详情

const getbossDetail = (params) => {
  return request.get(`/asset/gfmassmaintenanceunit/v1/info/${params.bizid}`, {params})
}
// 修改
const updatebossProtect = (params) => {
  return request.post('/asset/equip/project/v1/update', params)
}
// 设备巡检任务板块
// 设备巡检任务查询接口
const getcheckCountList = (params) => {
  return request.post('/asset/equip/inspectiontask/v1/list', params)
}
// 设备巡检任务删除接口
const deletecheckList = (params) => {
  return request.post('/asset/equip/inspectiontask/v1/delete', params)
}
const exportInspectionTaskList = (params) => {
  return request.post('/asset/equip/inspectiontask/v1/exportExcel', params, { responseType: 'blob' })
}
// 设备维保任务板块
// 设备维保任务查询接口
const getCheckTaskCountList = (params) => {
  return request.post('/asset/v1/gfmassmaintenance/selectMaiData', params)
}
// 设备维保任务删除接口
const deleteTaskList = (params) => {
  return request.post('/asset/v1/gfmassmaintenance/v1/deleteMaiInfo', params)
}
// 设备维保任务导出接口
const exportMaintenceTaskList = (params) => {
  return request.post('/asset/v1/gfmassmaintenance/v1/exportExcel', params, { responseType: 'blob' })
}
// 设备维保任务列表 查看变更记录
const getlistDetail = (params) => {
  return request.get('/asset/equip/inspectiontask/v1/listDetail', {params})
}

// 设备维保计划中的附件上传
const addReportAttachment = (params) => {
  return request.post('/asset/sys/gfmasscardattachment/v1/saveAttNoDept', params)
}
// 设备维保任务变更接口
const saveTaskDetail = (params) => {
  return request.post('/asset/v1/gfmassmaintenanceChangeRecord/saveMainChangeInfo', params)
}
// 设备维保详情
const maintenanceTaskInfo = (params) => {
  return request.get(`/asset/v1/gfmassmaintenance/v1/info/${params.bizid}`, {params})
}
// 设备维保详情列表
const maintenanceTaskDetailList = (params) => {
  return request.post('/asset/equip/maintenanceTaskDetail/v1/list', params)
}
// 设备巡检任务列表 查看变更记录
const selectMainChangeData = (params) => {
  return request.post('/asset/v1/gfmassmaintenanceChangeRecord/selectMainChangeData', params)
}

// 设备巡检详情
const inspectiontaskInfo = (params) => {
  return request.get(`/asset/equip/inspectiontask/v1/info/${params.bizid}`, {params})
}
// 设备巡检详情列表
const inspectiontaskDetailList = (params) => {
  return request.post('/asset/equip/inspectionTaskDetail/v1/list', params)
}
// 设备巡检 任务变更
const saveDetail = (params) => {
  return request.post('/asset/equip/inspectiontask/v1/saveDetail', params)
}
// 所属系统
const getClassTree = (params) => {
  return request.get('/asset/sys/gfmasseleclassbs/v1/getClassTypeTree', {params})
}

// 维保单位管理
// 维保单位管理查询接口
const gfmassmaintenanceunit = (params) => {
  return request.post('/asset/gfmassmaintenanceunit/v1/list', params)
}
// 维保单位管理删除接口
const deleteumicheckList = (params) => {
  return request.post('/asset/gfmassmaintenanceunit/v1/delete', params)
}
// 维保单位管理下载模版接口
const exportumiTem = (params) => {
  return request({
    url: '/asset/card/gfmasscardtem/v1/templateDownLoad',
    responseType: 'blob',
    method: 'get',
    params: params
  })
}
// 维保单位管理导出
const exportMainTaskList = (params) => {
  return request.post('/asset/gfmassmaintenanceunit/v1/exportExcel', params, { responseType: 'blob' })
}

// 巡检情况表 - 按月统计导出
const inspectionExportByMonth = (params) => {
  return request.post('/asset/PingAnReportForm/v1/getInspectionTaskExport', params, { responseType: 'blob' })
}

// 巡检情况表 - 按日统计导出
const inspectionExportByDay = (params) => {
  return request.post('/asset/PingAnReportForm/v1/InspectionTaskByDayExport', params, { responseType: 'blob' })
}

// 维保情况表 - 按月统计导出
const maintenanceExportByYear = (params) => {
  return request.post('/asset/PingAnReportForm/v1/getMaintenanceTaskExport', params, { responseType: 'blob' })
}

// 按批显示获取附件列表1
const getBatchAttachmentList = (params) => {
  return request.post('/asset/sys/gfmasscardattachment/v1/attachmentListShowBatch', params)
}
// 按批显示获取附件列表2
const getAttachmentList = (params) => {
  return request.post('/asset/sys/gfmasscardattachment/v1/attachmentListShowBatch', params)
}
// 获取附件类型
const getDictionaryList = (params) => {
  return request.get('/admin/sys/sformdict/getsformdictlist', {params})
}
// 月报删除附件
const delMonthAttachment = (params) => {
  return request.post('/asset/sys/gfmasscardattachment/v1/deleteNoDept', params)
}
// 删除附件
const delAttachment = (params) => {
  return request.post('/asset/sys/gfmasscardattachment/v1/delete', params)
}
// 查看附件
const view = (params) => {
  return request.get('/admin/admin/fileView/view', {params})
}
// 查看pdf
const viewFile = (params) => {
  return request.get('/admin/admin/sysFile/showImg', {params})
}

// 维保/巡检单位新增
const savexyProtect = (params) => {
  return request.post('/asset/gfmassmaintenanceunit/v1/save', params)
}
// 维保/巡检单位修改
const updatexyProtect = (params) => {
  return request.post('/asset/gfmassmaintenanceunit/v1/update', params)
}
// 维保/巡检单位查看
const viewxyProtect = (params) => {
  return request.get(`/asset/gfmassmaintenanceunit/v1/info/${params.bizid}`, {params})
}
// 获取任务列表对应巡检照片
const selectByTaskBizid = (params) => {
  return request.get('/asset/sys/gfmasscardattachment/v1/selectByTaskBizid', {params})
}
// // 获取任务列表对应巡检照片
const getAttachmentListpic = (params) => {
  return request.get('/asset/sys/gfmasscardattachment/v1/selectByRelateBizid', {params})
}
// 统计报表 - 巡检执行情况表
const getInspectionTaskByYear = (params) => {
  return request.post('/asset/PingAnReportForm/v1/getInspectionTask', params)
}
const getInspectionTaskByDate = (params) => {
  return request.post('/asset/PingAnReportForm/v1/getInspectionTaskByDay', params)
}
// 统计报表 - 维保执行情况表
const getMaintenanceTask = (params) => {
  return request.post('/asset/PingAnReportForm/v1/getMaintenanceTask', params)
}
export default {
  getAttachmentListpic,
  selectByTaskBizid,
  getOutCode,
  getDeviceListbyLocation,
  getCompanyMeter,
  saveMeterNew,
  exportMeterRecord,
  getTaskCount,
  getTaskCountList,
  deleteList,
  enable,
  disable,
  exportTem,
  getProtectTaskCountList,
  deleteProtectList,
  enableProtect,
  disableProtect,
  exportTemProtect,
  getcheckCountList,
  deletecheckList,
  getCheckTaskCountList,
  deleteTaskList,
  exportInspectionTaskList,
  exportMaintenceTaskList,
  getClassTree,
  gfmassmaintenanceunit,
  deleteumicheckList,
  exportumiTem,
  exportMainTaskList,
  inspectionExportByMonth,
  inspectionExportByDay,
  maintenanceExportByYear,
  getBatchAttachmentList,
  getDictionaryList,
  delMonthAttachment,
  delAttachment,
  getAttachmentList,
  view,
  getlistDetail,
  selectMainChangeData,
  saveDetail,
  saveTaskDetail,
  maintenanceTaskInfo,
  maintenanceTaskDetailList,
  inspectiontaskInfo,
  inspectiontaskDetailList,
  getitemDetail,
  getitemDetaillist,
  addReportAttachment,
  updateProtect,
  saveProtect,
  getclientToken,
  getToken,
  viewFile,
  getPingAnCookie,
  getxproDetail,
  saveXProtect,
  updateXProtect,
  getbossDetail,
  updatebossProtect,
  savexyProtect,
  updatexyProtect,
  getInspectionTaskByYear,
  getInspectionTaskByDate,
  getMaintenanceTask,
  viewxyProtect
}



// WEBPACK FOOTER //
// ./src/area-energyManage/api/deviceService.js